import Default from '../collections/default/Controller'
import Edisa from '../collections/edisa/Controller'

const Themes = {
  default: Default,
  edisa: Edisa,
}

export default Themes
